import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AddRewardPage from './pages/AddReward';
import Header from './components/Header';
import Login from './pages/Login';
import Home from './pages/Home';
import RewardDetails from './pages/RewardDetails';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import NotFoundPage from './pages/NotFoundPage';
function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/add-reward" element={<PrivateRoute><AddRewardPage /></PrivateRoute>} />
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/reward-details/:id" element={<PrivateRoute><RewardDetails /></PrivateRoute>} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;


